import {createStore} from "vuex";
import repositories from "@/Store/modules/repositories";
import canvas2 from "@/Store/modules/canvas2";

const store = createStore({

    modules: {
        repositories,
        canvas2,
    },

    state () {
        return {
            sidebar: {
                collapsed: false,
            },
            toolbox: {
                collapsed: false,
            },
        }
    },
    
    mutations: {
        sidebar_collapse_toggle (state) {
            state.sidebar.collapsed = !state.sidebar.collapsed;
        },
        toolbox_collapse_set (state, value) {
            state.toolbox.collapsed = !!value;
        },
        toolbox_collapse_toggle (state) {
            state.toolbox.collapsed = !state.toolbox.collapsed;
        }
    }
})

export default store;
